import { Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { usePerm } from '@/shared/hooks/usePerm';
import { PageHeader } from '@/shared/ui/layout/PageHeader';
import { EmptyState } from '@/shared/ui/feedback/EmptyState';

/**
 * Landing on /warehouse picks the tab the staff member can actually see:
 *   1. Orphan posilkalar (warehouse.view) — preferred per owner spec.
 *   2. Egasi bor posilkalar (parcels.list) — fallback.
 *   3. Neither permission → blocked page (the protected layout normally
 *      keeps these users away, but a stale link can still land here).
 *
 * Permissions come from localStorage cache via `useCurrentUser` (resolved
 * synchronously) so no loading state is needed.
 */
export const WidgetsWarehouseRedirect = () => {
  const { t } = useTranslation();
  const canOrphan = usePerm('warehouse.view');
  const canOwned = usePerm('parcels.list');

  if (canOrphan) return <Navigate to="/warehouse/orphan" replace />;
  if (canOwned) return <Navigate to="/warehouse/owned" replace />;

  return (
    <>
      <PageHeader title={t('warehouse.title')} />
      <div className="p-6">
        <EmptyState
          title={t('common.noAccessTitle')}
          description={t('common.noAccessDescription')}
        />
      </div>
    </>
  );
};
